/**
 * Short URL-safe tokens for patient consent links (/verify-dob/:accessToken).
 * Replaces long UUID+timestamp strings for cleaner emails.
 */
const TOKEN_ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

export function generateConsentAccessToken(length = 12) {
  const size = Math.max(8, Math.min(length, 24));
  const bytes = new Uint8Array(size);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < size; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  let token = '';
  for (let i = 0; i < size; i++) {
    token += TOKEN_ALPHABET[bytes[i] % TOKEN_ALPHABET.length];
  }
  return token;
}

export function buildConsentVerifyUrl(accessToken, origin) {
  const base = (origin || (typeof window !== 'undefined' ? window.location.origin : 'https://smileconsent.co.uk')).replace(/\/$/, '');
  return `${base}/verify-dob/${encodeURIComponent(accessToken)}`;
}
